// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"profileButton_buttonContainer__qCa0I","largerAvatarSize":"profileButton_largerAvatarSize__2eKiY","avatarSize":"profileButton_avatarSize__c_zp2"};